<script lang="ts">
  import type { Theme, LogoVariant } from '.';
  import logos from './logos';

  import { uuidv4 } from '$lib/utils';

  const uuid = uuidv4();

  export let variant: LogoVariant = 'logo';
  export let theme: Theme = 'dark';
  export let height = 'h-32';
  export let href: string | null = null;
</script>

<svelte:element this={href ? 'a' : 'div'} {href} class={height}>
  {@html logos[theme][variant](uuid)}
</svelte:element>
